import FormattedMessage from 'I18n/components/FormattedMessage';
import { CreditTile } from './CreditTile/CreditTile';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UsageCreditsUsed = ({
  isLoading,
  resetDays = 0,
  totalUsage,
  usageLimit,
  hasLowCredits
}) => /*#__PURE__*/_jsxs(CreditTile, {
  isLoading: isLoading,
  children: [/*#__PURE__*/_jsx(CreditTile.Count, {
    hasLowCredits: hasLowCredits,
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "hubSpotCredits.used",
      options: {
        totalUsage,
        usageLimit
      }
    })
  }), /*#__PURE__*/_jsx(CreditTile.Label, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubSpotCredits.titleMonthly"
    })
  }), /*#__PURE__*/_jsx(CreditTile.Reset, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubSpotCredits.resetDays",
      options: {
        count: resetDays
      }
    })
  })]
});